export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    public detail: string = '',
  ) {
    super(detail || code);
    this.name = 'ApiError';
  }
}

export async function api<T>(path: string, opts: RequestInit = {}): Promise<T> {
  // Törzs nélküli POST/PUT/PATCH: üres JSON-törzs, különben a szerver elutasítja ("Body cannot be empty").
  const method = (opts.method ?? 'GET').toUpperCase();
  const body = opts.body ?? (['POST', 'PUT', 'PATCH'].includes(method) ? '{}' : undefined);
  // Törzs nélküli kérésnél (GET/DELETE) nincs content-type: JSON-fejléc üres törzzsel 400-at ad („Body cannot be empty").
  const headers: Record<string, string> = { ...(body !== undefined ? { 'content-type': 'application/json' } : {}), ...((opts.headers as Record<string, string> | undefined) ?? {}) };
  const res = await fetch(path, { credentials: 'same-origin', ...opts, body, headers });

  const text = await res.text();
  const data: unknown = text ? JSON.parse(text) : {};

  if (!res.ok) {
    const code =
      typeof data === 'object' && data !== null && 'error' in data
        ? String((data as { error: unknown }).error)
        : `http_${res.status}`;
    const detail = typeof data === 'object' && data !== null && 'message' in data ? String((data as { message: unknown }).message) : '';
    throw new ApiError(res.status, code, detail);
  }
  return data as T;
}
